import DocumentReader from "../components/DocumentReader"
import { getLibraryContentUrl } from "../Helpers"


export default function BookAccess({ data, watermark }) {
  return <DocumentReader
    data={{ ...data, contentUrl: getLibraryContentUrl(data.fileAccessToken) }}
    label="book"
    watermark={watermark}
  />
}
